import React from 'react';
import VerifyEmailForm from '@common/components/AccountMultiStep/forms/verifyEmail/VerifyEmailForm';
import {
  CompleteVerifyFormData,
  ResponseErrors
} from '@common/components/AccountMultiStep/forms/verifyEmail/types';
import { StepWrapper } from '@common/components/Caja/components';
import {
  useSendVerificationEmail,
  useVerifyEmail
} from '@common/hooks/account';
import { TopLevelStep } from '@common/hooks/multiStep';
import { useRedirectUnauthenticatedUser } from '@common/hooks/useRedirectUnauthenticatedUser';
import { useTranslation } from '@common/hooks/useTranslation';
import { getUser } from '@store/auth';
import { useAppSelector } from '@store/hooks';

type Props = Pick<TopLevelStep<undefined>, 'onCompleted'>;

export function VerifyEmail({ onCompleted }: Props) {
  useRedirectUnauthenticatedUser();

  const { t } = useTranslation();
  const { currentUser } = useAppSelector(getUser);
  const verifyEmail = useVerifyEmail();
  const sendVerificationEmail = useSendVerificationEmail();

  async function onVerifySubmit(data: CompleteVerifyFormData) {
    const { isSuccessful, error } = await verifyEmail({
      verificationCode: data.emailVerificationCode
    });
    return { isSuccessful, error };
  }

  async function verifyFormSubmit(
    data: CompleteVerifyFormData
  ): Promise<void | ResponseErrors> {
    const { isSuccessful, error } = await onVerifySubmit(data);

    if (error) {
      return { field: 'emailVerificationCode', errorMessage: error.message };
    }

    if (isSuccessful) onCompleted({});
  }

  async function resendVerificationEmail() {
    await sendVerificationEmail({ isResend: true });
  }

  return (
    <StepWrapper>
      <VerifyEmailForm
        submitBtnText={t('common.action.next')}
        userEmail={currentUser.email || ''}
        onResend={resendVerificationEmail}
        onSubmit={verifyFormSubmit}
      />
    </StepWrapper>
  );
}
